import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ToastProvider } from '@jywer/ui';
import App from './App';
import { PermissionsBoot } from './permissions-boot';
import './index.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root element not found in index.html');

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <PermissionsBoot>
          <App />
        </PermissionsBoot>
      </ToastProvider>
    </BrowserRouter>
  </StrictMode>,
);
